const BaseEntry = require('./BaseEntry');
const getConstants = require('../../../utils/getConstants');
const constants = getConstants();
const _ = require('../../../lodash');
const classifyRepeaterEntryMode = require('../utilities/classifyRepeaterEntryMode');
const { kinds: repeaterEntryModeKinds } = classifyRepeaterEntryMode;
const { answerStates, repeaterFormItemTypes } = constants;
class RepeaterGroupEntry extends BaseEntry {
   constructor(aggregateRoot, componentData, items, entries, ruleEvaluator) {
      super(aggregateRoot, componentData, items, entries, ruleEvaluator);
   }

   changeRepeaterGroupListItem({ actionedOn, idListItem, geoLat, geoLong, geoTimeStamp }) {
      const item = this.item;

      const noResponse = item.response ? item.response.no : 1;
      const newItemState = item.state; // No change....

      var p = {
         idItem: this.idItem,
         state: newItemState,
         actionedOn,
         noResponse,
         val: idListItem,
         noSubmissionItem: item.no,
         noSubmission: this._aggregateRoot.getSubmissionNo(),
         geoLat,
         geoLong,
         geoTimeStamp
      };

      this.apply('REPEATER_GROUP_LIST_ITEM_CHANGED', p);

      item.response = item.response || {};
      item.response.no = noResponse;
      item.response.val = idListItem;
      item.response.actionedOn = actionedOn;
      item.state = newItemState;
      item.geoLat = geoLat;
      item.geoLong = geoLong;
      item.geoTimeStamp = geoTimeStamp;
   }

   getRowKey() {
      return this.item && this.item.response ? this.item.response.val : null;
   }

   lock() {
      const item = this.item;
      const { state } = item;
      item.state = state | answerStates.LOCKED;

      for (var i = 0; i < this.children.length; i++) {
         const e = this.children[i];
         e.lock();
      }
   }

   unlock() {
      const item = this.item;
      const { state } = item;
      item.state = state & ~answerStates.LOCKED;

      for (var i = 0; i < this.children.length; i++) {
         const e = this.children[i];
         e.unlock();
      }
   }

   hasFailures() {
      let isFailed = false;

      for (var i = 0; i < this.children.length; i++) {
         const e = this.children[i];
         if (e.hasFailures()) {
            isFailed = true;
         }
      }
      return isFailed;
   }

   countFlags() {
      let flagged = false;
      let noOfFlags = 0;

      for (var i = 0; i < this.children.length; i++) {
         const e = this.children[i];

         const flagResult = e.countFlags();

         if (flagResult.flagged) {
            flagged = true;
            noOfFlags = noOfFlags + (flagResult.noOfFlags || 1);
         }
      }

      return {
         flagged,
         noOfFlags
      };
   }

   refreshValidityFromChildren() {
      return this.setCurrentValidity(this.areImmediateChildrenCurrentlyValid());
   }

   validate() {
      let isValid = true;

      for (var i = 0; i < this.children.length; i++) {
         const e = this.children[i];
         if (!e.validate()) {
            isValid = false;
         }
      }

      return this.setCurrentValidity(isValid);
   }

   score() {
      let overallScore = null;
      let overallMaxScore = null;

      for (var i = 0; i < this.children.length; i++) {
         const e = this.children[i];
         const scoreResult = e.score();

         overallScore =
            scoreResult.score == null ? overallScore : overallScore == null ? scoreResult.score : overallScore + scoreResult.score;

         overallMaxScore =
            scoreResult.maxScore == null
               ? overallMaxScore
               : overallMaxScore == null
               ? scoreResult.maxScore
               : overallMaxScore + scoreResult.maxScore;
      }

      if (this.item) {
         this.item.score = overallScore;
         this.item.maxScore = overallMaxScore;
      }

      return {
         score: overallScore,
         maxScore: overallMaxScore
      };
   }

   refresh() {
      const repeater = _.find(this.items, (x) => x.id === this.item.idParent);
      const options = repeater?.options || {};
      const classification = repeater
         ? classifyRepeaterEntryMode({
              idRepeaterType: options.idRepeaterType,
              entryMode: options.entryMode,
              idRepeaterCadence: options.idRepeaterCadence,
              timesToRepeat: options.timesToRepeat
           })
         : null;

      if (classification?.kind === repeaterEntryModeKinds.CANONICAL_FULL_LIST) {
         return;
      }

      this.item.label = this.getFriendlyValue();
   }

   getGroupName() {
      if (!this.item.response) {
         return this.item.label || null;
      }

      const repeater = _.find(this.items, (x) => x.id === this.item.idParent);
      if (!repeater || !this.isOfListType(repeater)) {
         return this.item.label || null;
      }

      const binding = repeater.options?.binding || {};
      const idField = binding.idField || 'id';
      const txtField = binding.txtField || 'txt';
      const listOptions = Array.isArray(repeater.options?.listOptions) ? repeater.options.listOptions : [];
      const listItem = _.find(listOptions, (x) => x?.[idField] != null && x[idField].toString() == this.item.response.val.toString());

      if (listItem && listItem[txtField] != null) {
         return listItem[txtField];
      }

      return this.item.label || null;
   }

   isOfListType(repeater) {
      return repeater.options && repeater.options.idRepeaterType == repeaterFormItemTypes.LIST.id;
   }

   getFriendlyValue() {
      let label = '';

      let groupName = this.getGroupName();

      if (groupName != null) {
         label = groupName;
      }

      /*
      -- This would be better in a second 'label' prop as it just wraps
      for (var i = 0; i < this.children.length; i++) {
         const e = this.children[i];
         let childLabel = e.getFriendlyValue();
         if (childLabel != '') {
            if (label.length > 0) {
               label += ' | ';
            }
            label += childLabel;
         }
      }
      */

      return label;
   }
}

module.exports = RepeaterGroupEntry;
